import { render, staticRenderFns } from "./confirmFeeManagement.vue?vue&type=template&id=67b29e36&scoped=true&"
import script from "./confirmFeeManagement.vue?vue&type=script&lang=ts&"
export * from "./confirmFeeManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b29e36",
  null
  
)

export default component.exports